// import { TableRow } from '@material-ui/core';
import React, {useEffect, useState} from 'react';
import Box from '@material-ui/core/Box';
import Collapse from '@material-ui/core/Collapse';
import IconButton from '@material-ui/core/IconButton';
import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import Typography from '@material-ui/core/Typography';
import Paper from '@material-ui/core/Paper';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import useFetch, {CachePolicies} from 'use-http';
import {useTranslation} from 'react-i18next';
import moment from 'moment';
import {Skeleton} from 'antd';


function ShowReportPost() {
    const [reportPostData, setReportPostData] = useState([])
    // const [rows,setRows] = useState<any>([])

    const reportPostApi = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/report/post`, {
        cachePolicy: CachePolicies.NO_CACHE,
    });
    const { t } = useTranslation();
    

    function createData(
        Id: string, /* id feed */
        UserId: string, /* คนที่โพส */
        Title: string,
        Content: string,
        PublicAt: string,
        Privacy: string,
        Summary: string,
      
    ) {
        return {
            Id,
            UserId,
            Title,
            Content,
            PublicAt,
            Privacy,
            Summary,
        };
    }

    const convertTime = (date: any) => {
        let lang: any = localStorage.getItem("lang");
        if (lang === "th") {
            moment.locale(lang);
            let dt = moment(date).format(`DD MMMM YYYY HH:mm`);
            let t_date = dt.split(" ")[0];
            let t_month = t(dt.split(" ")[1]);
            let t_year = dt.split(" ")[2];
            let t_time = dt.split(" ")[3];
            return `${t_date} ${t_month} ${parseInt(t_year) + 543}, ${t_time} น.`;
        } else {
            moment.locale(lang);
            return moment(date).format("DD MMMM YYYY hh:mm A");
        }
    };
   
   
    function Row(props: { row: ReturnType<typeof createData> }) {

        const reporterPostApi = useFetch(window.__RUNTIME_CONFIG__.REACT_APP_PLAYME_URL + `api/v1/report/reporter/`, {
            cachePolicy: CachePolicies.NO_CACHE,
        });

        const { row } = props;
        const [open, setOpen] = React.useState(false);
        const [reporter, setReporter] = React.useState([]);
        
        // console.log("row => ",row);
        
        const reporterPostLoad = async (id:any) => {
            const reportPosterRes = await reporterPostApi.get(id);
            console.log("reportPosterRes => ",reportPosterRes);
            
            setReporter(reportPosterRes)
        }

        
        useEffect(()=>{
            if(!open) return

            reporterPostLoad(row?.Id)
        },[open])

        
        return (
            <React.Fragment>
                <TableRow >
                    <TableCell>
                        <IconButton
                            aria-label="expand row"
                            size="small"
                            onClick={() => setOpen(!open)}
                        >
                            {open ? <KeyboardArrowUpIcon /> : <KeyboardArrowDownIcon />}
                        </IconButton>
                    </TableCell>
                    <TableCell component="th" scope="row">
                        {row?.Id}
                    </TableCell>
                    <TableCell >{row?.UserId}</TableCell>
                    <TableCell >{row?.Title}</TableCell>
                    <TableCell >{<div style={{whiteSpace: "nowrap",textOverflow: "ellipsis", overflow: "hidden",maxWidth:"50vh"}}>{row?.Content}</div>}</TableCell>
                    <TableCell >{convertTime(row?.PublicAt)}</TableCell>
                    <TableCell >{row?.Privacy}</TableCell>
                    <TableCell >{row?.Summary}</TableCell>
                </TableRow>
                <TableRow>
                    <TableCell style={{ paddingBottom: 0, paddingTop: 0 }} colSpan={10}>
                        <Collapse in={open} timeout="auto" unmountOnExit>
                            <Box sx={{ margin: 10 }}>
                                <Typography variant="h6" gutterBottom component="div">
                                    {t("Reporter")}
                                </Typography>
                                {(!reporterPostApi.loading) && <Table size="small" aria-label="purchases">
                                    <TableHead>
                                        <TableRow>
                                            <TableCell>{t("User Id")}</TableCell> {/* คนที่ report */}
                                            <TableCell>{t("Topic Report")}</TableCell>
                                            <TableCell>{t("Reason Report")}</TableCell>
                                            <TableCell>{t("Date Report")}</TableCell>
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {reporter.map((reporterRow: any, index: number) => (
                                            <TableRow key={index}>
                                                <TableCell component="th" scope="row">
                                                    {reporterRow.userID}
                                                </TableCell>
                                                <TableCell>{reporterRow.reportTopic}</TableCell>
                                                <TableCell >{reporterRow.reportReason}</TableCell>
                                                <TableCell >{convertTime(reporterRow.createdAt)}</TableCell>
                                            </TableRow>
                                        ))}
                                    </TableBody>
                                </Table>}
                                {(reporterPostApi.loading ) && <Skeleton active />}
                            </Box>
                        </Collapse>
                    </TableCell>
                </TableRow>
            </React.Fragment>
        );
    }

    // const xxx = [
    //     createData('8983fd3b-8065-4816-903f-1df1bc5f40bd',"chphakphoom@gmail.com", "ee", "eeee", "2022-10-12 15:49:44.322 +0700", "public", "3", [
    //         {
    //             userId: 'chphakphoom@gmail.com',
    //             topicReport: 'It expresses intentions of self-harm or suicide',
    //             reasonReport: "Test Report",
    //             dateReport: '2022-09-13 16:39:03.440 +0700',
    //         }
    //     ]),
    // ];

    useEffect(() => {
        reportPostLoad()
    }, [])

    const reportPostLoad = async () => {
        const reportPostData = await reportPostApi.get();
        console.log("data => ", reportPostData);


        const data = reportPostData?.map((feedReport: any) => {
            console.table("item => ", feedReport);

            // return (createData(feedReport?.id, feedReport?.userID, feedReport?.title, feedReport?.content, feedReport?.publishAt, feedReport?.privacy, feedReport?.summary, [
            //     // {
            //     //     userId: 'chphakphoom@gmail.com',
            //     //     topicReport: 'It expresses intentions of self-harm or suicide',
            //     //     reasonReport: "Test Report",
            //     //     dateReport: '2022-09-13 16:39:03.440 +0700',
            //     // }
            // ]))
            return (createData(feedReport?.id, feedReport?.userID, feedReport?.title, feedReport?.content, feedReport?.publishAt, feedReport?.privacy, feedReport?.summary))
        })
        console.log("map1 => ", data);



        setReportPostData(data)
    }

    return (
        <div style={{ padding: "50px" }}>
            <TableContainer component={Paper}>
                <Table aria-label="collapsible table">
                    <TableHead>
                        <TableRow>
                            <TableCell />
                            <TableCell>{t("Post Id")}</TableCell>
                            <TableCell>{t("User Id")}</TableCell>
                            <TableCell>{t("Title")}</TableCell>
                            <TableCell>{t("Content")}</TableCell>
                            <TableCell>{t("Publish At")}</TableCell>
                            <TableCell>{t("Privacy")}</TableCell>
                            <TableCell>{t("Summary")}</TableCell>
                        </TableRow>
                    </TableHead>
                    {(!reportPostApi.loading ) && <TableBody>
                        {reportPostData?.map((row: any) => (
                            <Row key={row?.id} row={row} />
                        ))}
                    </TableBody>}
                </Table>
                {(reportPostApi.loading ) && <Skeleton active />}
            </TableContainer>
        </div>
    );
}

export default ShowReportPost;
